import React from 'react';
import { ReactNode } from 'react';
import { InputHTMLAttributes } from 'react';
import { Container, Label, Input, InputBox } from './styles';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  right?: ReactNode;
};

export default function FormInput(props: Props) {
  return (
    <Container>
      <Label>{props.label}</Label>
      <InputBox>
        <Input {...props} />
        {props.right && props.right}
      </InputBox>
    </Container>
  );
}
